<div class="di-menu-groupe-journee">
  <lua-list-item text="Changer l'infirmier" [isDisabled]="!(seances && seances.length > 0)" iconName="group" (click)="onChangerInfirmierClick($event)" ></lua-list-item>
  <lua-list-item text="Ajouter un évènement"  iconName="calendar_month" (click)="onAjouterEvenementClick($event)" ></lua-list-item>
</div>